import { createSlice } from "@reduxjs/toolkit";

// 🔥 Load from localStorage
const savedAuth = JSON.parse(localStorage.getItem("authData"));

const loginSlice = createSlice({
  name: "login",
  initialState: savedAuth || {
    isAuthenticated: false,
    isLoggedIn: false,   // 👈 added
    isAdmin: false,
    userEmail: null,
  },

  reducers: {
    login: (state, action) => {
      const { email, password } = action.payload;

      if (email === "mcc@gmail.com" && password === "mcc") {
        state.isAuthenticated = true;
        state.isLoggedIn = true;   // 👈 added
        state.isAdmin = true;
        state.userEmail = email;
      } else {
        state.isAuthenticated = true;
        state.isLoggedIn = true;   // 👈 added
        state.isAdmin = false;
        state.userEmail = email;
      }

      // 🔥 Save to localStorage
      localStorage.setItem(
        "authData",
        JSON.stringify({
          isAuthenticated: state.isAuthenticated,
          isLoggedIn: state.isLoggedIn,   // 👈 added
          isAdmin: state.isAdmin,
          userEmail: state.userEmail,
        })
      );
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.isLoggedIn = false;   // 👈 added
      state.isAdmin = false;
      state.userEmail = null;

      // 🔥 Remove from localStorage
      localStorage.removeItem("authData");
    },
  },
});

export const { login, logout } = loginSlice.actions;
export default loginSlice.reducer;